import { errorCodesEnglish, mapErrorCodeToUiMessage } from 'noddi-util';
import { ApiErrorMessageProps } from '..';
import { NoddiFeedbackBox } from '../../../../molecules';

export function ApiErrorMessage({ error, errorCodes }: ApiErrorMessageProps) {
  return (
    <div className='mt-2'>
      <NoddiFeedbackBox
        variant='error'
        description={mapErrorCodeToUiMessage({
          error,
          errorCodes: errorCodes ?? errorCodesEnglish
        })}
      />
    </div>
  );
}

interface ErrorMessageProps {
  message: string;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className='mt-2'>
      <NoddiFeedbackBox variant='error' description={message} />
    </div>
  );
}
